import React, { useCallback, useMemo, useState } from 'react';
import { Label, LookupField } from '@crx-dev/hss-react-components';
import { makeRequest } from '@crx-dev/hss-react-infrastructure';
import { useQuery } from 'react-query';
import { ProductLookupResponse } from './types/ProductLookupResponse';

interface ProductLookupProps {
    name: string;
    value: any;
    onChange: (value: any) => void;
    error?: string;
    marginTop?: number;
    marginBottom?: number;
}

function ProductLookup({ error, ...props }: ProductLookupProps) {
    const [searchValue, setSearchValue] = useState('');

    const { data, isLoading, isFetching } = useQuery<ProductLookupResponse[]>(
        ['products', searchValue],
        () =>
            makeRequest({
                method: 'GET',
                path: `/api/v1/productsearch`,
                data: {
                    search: searchValue
                }
            }),
        {
            enabled: searchValue.length > 0,
            cacheTime: 0,
            keepPreviousData: true
        }
    );

    const products = useMemo(
        () =>
            data
                ? data.map(x => ({
                      value: x.resipId,
                      label: x.productName
                  }))
                : [],
        [data]
    );

    const handleSearch = useCallback(value => {
        setSearchValue(value);
    }, []);

    return (
        <>
            <Label htmlFor="selectedProduct" label="Select a Product" />
            <LookupField
                isLoading={isLoading || isFetching}
                error={error}
                {...props}
                label=""
                placeholder="Search..."
                options={products}
                onSearch={handleSearch}
            />
        </>
    );
}

export default ProductLookup;
